import { GET_SUBSCRIPTIONS } from "constants/subscriptions";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_SUBSCRIPTIONS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
